// Worth a look's figures and weeks in words (PLAN-2026-10-27-worth-a-look §5,
// §6), one copy for the page and the League page's card.

import type { WorthALookView } from '@fsp/domain';

/** "22.1", "8": a figure as the site writes points. */
export function pointsText(n: number): string {
  return Number.isInteger(n) ? String(n) : n.toFixed(1);
}

/** "Weeks 6 and 7", "Week 1": what the figures are over. */
export function weeksText(view: Pick<WorthALookView, 'weeks'>): string {
  const [a, b] = view.weeks;
  if (a === undefined) return '';
  if (b === undefined) return a.label;
  const numbered = /^Week \d+$/;
  return numbered.test(a.label) && numbered.test(b.label)
    ? `Weeks ${a.label.slice(5)} and ${b.label.slice(5)}`
    : `${a.label} and ${b.label}`;
}
